import axiosInstance from '../../util/axiosAPI';
import { API_URL } from '../../config';

export default class GnssControllerApi {

    constructor() { }

    async status() {
        const url = `${API_URL}/api/gnss/controller/status/`;
        return axiosInstance.get(url).then(response => response.data);
    }

    async restart() {
        const url = `${API_URL}/api/gnss/controller/restart/`;
        return axiosInstance.get(url).then(response => response.data);
    }

    async logs(lines = 100) {
        const url = `${API_URL}/api/gnss/controller/logs/?lines=${lines}`;
        return axiosInstance.get(url).then(response => response.data);
    }

    async gpsData() {
        const url = `${API_URL}/api/gnss/gps-data/`;
        return axiosInstance.get(url).then(response => response.data);
    }

}
